import { Typography } from "PFComponents/typography";
import { DateRangePair } from "PFCore/types";
import React from "react";

import css from "../suggested_changes.module.scss";
import { useFormatBookingDates } from "../use_format_booking_dates";

type BookingPillContentProps = Partial<DateRangePair>;

export const BookingPillContent = ({ startDate, endDate }: BookingPillContentProps) => {
  const { formatBookingDates } = useFormatBookingDates();

  const bookingDates = startDate && endDate ? formatBookingDates(startDate, endDate) : undefined;

  return (
    <div className={css.bookingPillContent}>
      {bookingDates && (
        <Typography withMargin variant="bodyBold" tag="span">
          {bookingDates}
        </Typography>
      )}
    </div>
  );
};
